import { createTheme } from "@mui/material/styles";
import colors from "./colors";

const theme = createTheme({
  typography: {
    fontSize: 14,
    htmlFontSize: 16,
    h1: {
      fontSize: "6rem",
    },
    h2: {
      fontSize: "3.75rem",
    },
    h3: {
      fontSize: "3rem",
    },
    h4: {
      fontSize: "2.125rem",
    },
    h5: {
      fontSize: "1.5rem",
    },
    h6: {
      fontSize: "1.25rem",
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
      letterSpacing: "0.00938em",
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.43,
      letterSpacing: "0.01071em",
    },
    button: {
      fontSize: "0.875rem",
      lineHeight: 1.75,
      letterSpacing: "0.02857em",
    },
    caption: {
      fontSize: "0.75rem",
      lineHeight: 1.66,
      letterSpacing: "0.03333em",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: "0.875rem",
          lineHeight: 1.43,
          letterSpacing: "0.01071em",
        },
      },
    },
  },
  palette: {
    background: {
      default: colors.white,
    },
    common: {
      black: colors.black,
      white: colors.white,
    },
    primary: {
      main: colors.primary,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.brand,
      contrastText: colors.white,
      dark: colors.brandDark,
    },
    error: {
      main: colors.error,
      contrastText: colors.white,
    },
  },
});

export default theme;
